import { freightRateConstants } from '../../_constants';

export function freightRates(state = {}, action) {
    switch (action.type) {
        case freightRateConstants.FREIGHT_RATE_FETCHING:
            return {
                ...state,
                freightRateFetching: true
            };
        case freightRateConstants.FREIGHT_RATE_FETCHED:
            return {
                ...state,
                freightRateFetching: false
            };
        case freightRateConstants.GET_ALL_FREIGHT_RATES:
            return {
                ...state,
                freightRates: action.freightRates
            };
        case freightRateConstants.GET_FREIGHT_RATES:
            return {
                ...state,
                freightRates: action.freightRates
            };
        case freightRateConstants.GET_FREIGHT_RATE_BY_ID:
            return {
                ...state,
                freightRate: action.freightRate
            };
        case freightRateConstants.UPDATE_FREIGHT_RATE:
            return {
                ...state,
                updating: true
            };
        case freightRateConstants.SEARCH_FREIGHT_RATES:
            return {
                ...state,
                freightRates: action.freightRates
            };
        case freightRateConstants.GET_FREIGHT_RATES_CHARGE:
            return {
                ...state,
                freightRateCharge: action.freightRateCharge
            };
        case freightRateConstants.GET_FREIGHT_RATES_ORIGIN:
            return {
                ...state,
                freightRateOrigin: action.freightRateOrigin
            };
        case freightRateConstants.GET_FREIGHT_RATES_CHARGE_ORIGIN:
            return {
                ...state,
                freightRates: action.freightRates
            };
        default:
            return state;
    }
}